<template>
  <div class="course-plan-page">
    <!-- 年度选择和操作按钮 -->
    <div class="header-row">
      <el-select v-model="classYear" placeholder="课程年度" style="width: 100px; margin-right: 10px"
        @change="handleClassYearChange">
        <el-option :label="item" :value="item" v-for="(item, index) in yearList" :key="index"></el-option>
      </el-select>
      <span class="main-title">{{ userClass.className }}</span>
      <div class="header-actions">
        <el-button size="small" @click="onHistoryPrint">历史打印记录</el-button>
        <el-button size="small" @click="onPrintCertificate">打印证书</el-button>
        <el-button size="small" @click="onPrintRegister">打印登记表</el-button>
      </div>
    </div>
    <!-- Tab 标题 -->
    <div class="tab-header">
      <span v-for="(tab, idx) in tabs" :key="tab" :class="['tab-item', { active: idx === activeTab }]"
        @click="handleActiveTab(idx)">{{ tab }}</span>
    </div>
    <div v-if="activeTab == 0">
      <!-- 课程计划卡片 -->
      <el-card class="course-plan-card" shadow="never">
        <div class="credit-info">
          <!-- 学时统计（红色） -->
          <span class="required">
            打印证书和登记表规则: 公需课必修必须完成
            {{ userClass.requiredCourseHour }}学时, 公需课选修需完成
            {{ userClass.optionalCourseHour }} 学时
          </span>
        </div>
        <!-- 课程图片和简介 -->
        <div class="plan-main">
          <img class="plan-img" src="@/assets/image/Snipaste_2025-07-23_19-52-53.png" alt="plan" />
          <div class="plan-info">
            <div class="plan-title">{{ userClass.className }}</div>
            <div class="plan-row">培训时间: {{ userClass.trainStartDate }}</div>
            <div class="plan-row">
              考核学时:
              {{ userClass.requiredCourseHour + userClass.optionalCourseHour }}
              已获取学时:
              {{
                userClass.haveOptionalCourseHour +
                userClass.haveRequiredCourseHour
              }}
            </div>
            <div class="plan-row">计划介绍: {{ userClass.introduction }}</div>
          </div>
        </div>
      </el-card>
      <!-- 课程类型 Tab -->
      <div class="course-type-tabs">
        <el-button v-for="(type, idx) in courseTypes" :key="type"
          :type="activeCourseType === idx ? 'primary' : 'default'" size="small" @click="handleActiveCourse(idx)"
          style="margin-right: 8px">{{ type }}</el-button>
      </div>
      <div class="course-stat">
        <span style="color: #e74c3c" v-if="activeCourseType == 0">
          线上培训-必修课学时合计: 需要完成
          {{ userClass.requiredCourseHour }}学时, 已学
          {{ userClass.haveRequiredCourseHour }}学时
        </span>
        <span style="color: #e74c3c" v-else>
          线上培训-选修课学时合计: 需要完成
          {{ userClass.optionalCourseHour }}学时, 已学
          {{ userClass.haveOptionalCourseHour }}学时
        </span>
      </div>

      <!-- 课程表格 -->
      <el-table :data="tableData" border style="width: 100%; margin-top: 12px" size="small">
        <el-table-column prop="idCardNo" label="身份证号码" width="180"></el-table-column>
        <el-table-column prop="classGroupName" label="题目"></el-table-column>
        <el-table-column prop="learnHour" label="学时" width="80"></el-table-column>
        <el-table-column prop="isExam" label="是否必考" width="90">
          <template v-slot="scope">
            <el-tag v-if="scope.row.isExam == 1" type="success">是</el-tag>
            <el-tag v-else type="info">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="completeTime" label="获得时间" width="120"></el-table-column>
      </el-table>
    </div>
    <!-- 线下培训记录 -->
    <div v-if="activeTab == 1">
      <!-- 课程计划卡片 -->
      <el-card class="course-plan-card" shadow="never">
        <div class="credit-info">
          <!-- 学时统计（红色） -->
          <span class="required">
            专业科目打印登记表规则: 满足
            {{ userClass.requiredCourseHour + userClass.optionalCourseHour }}
            学时
          </span>
        </div>
        <!-- 课程图片和简介 -->
        <div class="plan-main">
          <img class="plan-img" src="@/assets/image/Snipaste_2025-07-23_19-52-53.png" alt="plan" />
          <div class="plan-info">
            <div class="plan-title">{{ userClass.className }}</div>
            <div class="plan-row">培训时间: {{ userClass.trainStartDate }}</div>
            <div class="plan-row">
              考核学时:
              {{ userClass.requiredCourseHour + userClass.optionalCourseHour }}
              已获取学时:
              {{
                userClass.haveOptionalCourseHour +
                userClass.haveRequiredCourseHour +
                userClass.haveOfflineLearnHour
              }}
            </div>
            <div class="plan-row">计划介绍: {{ userClass.introduction }}</div>
          </div>
        </div>
      </el-card>

      <div class="course-type-tabs">
        <el-button @click="handleActiveCourseTag(1)" :type="handleActiveCourseTagType == 1 ? 'primary' : 'default'"
          style="margin-right: 8px" size="small">线上培训</el-button>
        <el-button @click="handleActiveCourseTag(2)" :type="handleActiveCourseTagType == 2 ? 'primary' : 'default'"
          size="small">线下培训</el-button>
      </div>
      <div class="course-stat">
        <span style="color: #e74c3c" v-if="handleActiveCourseTagType == 1">
          线上培训-学时合计: 需要完成
          {{ userClass.requiredCourseHour + userClass.optionalCourseHour }}学时, 已学
          {{ userClass.haveOptionalCourseHour + userClass.haveRequiredCourseHour }}学时
        </span>
        <span style="color: #e74c3c" v-if="handleActiveCourseTagType == 2">
          线下培训-学时合计: 已获取
          {{ userClass.haveOfflineLearnHour }}学时
        </span>
      </div>
      <!-- 课程表格 -->
      <div v-if="handleActiveCourseTagType == 1">
        <el-table :data="tableData" border style="width: 100%; margin-top: 12px" size="small">
          <el-table-column prop="idCardNo" label="身份证号码" width="180"></el-table-column>
          <el-table-column prop="classGroupName" label="题目"></el-table-column>
          <el-table-column prop="learnHour" label="学时" width="80"></el-table-column>
          <el-table-column prop="isExam" label="是否必考" width="90">
            <template v-slot="scope">
              <el-tag v-if="scope.row.isExam == 1" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="completeTime" label="获得时间" width="120"></el-table-column>
        </el-table>
      </div>
      <div v-else>
        <el-card class="course-plan-card" shadow="never">
          <div style="font-weight: bold; text-align: center">
            线下培训认定
          </div>
          <div style="margin-bottom: 40px; background-color: #fff">
            <el-table :data="dataList" style="width: 100%; margin-bottom: 20px">
              <el-table-column prop="recognitionStatus" label="认证申报状态" width="110px">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.recognitionStatus === 0" type="info">待申报</el-tag>
                  <el-tag v-if="scope.row.recognitionStatus === 1" type="success">已提交</el-tag>
                  <el-tag v-if="scope.row.recognitionStatus === 2" type="danger">审批中</el-tag>
                  <el-tag v-if="scope.row.recognitionStatus === 3" type="danger">审批通过</el-tag>
                  <el-tag v-if="scope.row.recognitionStatus === 4" type="danger">审批不通过</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="studentName" label="申报人">
              </el-table-column>
              <el-table-column prop="applyDepartment" label="申报单位">
              </el-table-column>
              <el-table-column prop="approvalDepartment" label="审批单位">
              </el-table-column>
              <el-table-column prop="applyTime" label="申报时间" width="110px">
              </el-table-column>
              <el-table-column prop="courseTitle" label="课题"> </el-table-column>
              <el-table-column prop="address" label="操作" align="center">
                <template v-slot="scope">
                  <el-button type="mini" @click="handleEdit(scope.row, true)">
                    查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <div style="
              display: flex;
              justify-content: flex-end;
              padding-bottom: 10px;
            ">
              <el-pagination :page-size="pageSize" background layout="prev, pager, next" :total="total"
                @current-change="currentChange">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
      <!-- 弹窗 -->

      <el-dialog title="申报认证" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" :rules="rules">
        <el-form :label-position="labelPosition" label-width="100px" ref="ruleForm" :model="ruleForm"
          class="demo-ruleForm">
          <div style="display: flex">
            <div style="width: 500px; margin-right: 20px">
              <el-form-item label="认定类型" prop="recognitionType">
                <el-select style="width: 100%" v-model="ruleForm.recognitionType" :disabled="disabled"
                  placeholder="请选择认定类型">
                  <el-option v-for="(item, index) in recognitionTypeList" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="课程科目" prop="courseTitle">
                <el-input :disabled="disabled" v-model="ruleForm.courseTitle" placeholder="请输入课程科目"></el-input>
              </el-form-item>
              <el-form-item label="举办部门" prop="department">
                <el-input :disabled="disabled" v-model="ruleForm.department" placeholder="请输入举办部门"></el-input>
              </el-form-item>
              <el-form-item label="学习地点" prop="learnLocation">
                <el-input :disabled="disabled" v-model="ruleForm.learnLocation" placeholder="请输入学习地点"></el-input>
              </el-form-item>
              <el-form-item label="学习形式" prop="learnMethod">
                <el-select :disabled="disabled" style="width: 100%" v-model="ruleForm.learnMethod"
                  placeholder="请选择学习形式">
                  <el-option v-for="(item, index) in learnMethodList" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="培训开始时间" prop="startTime">
                <el-date-picker :disabled="disabled" type="date" format="yyyy-MM-dd" placeholder="请输入培训开始时间"
                  v-model="ruleForm.startTime" style="width: 100%"></el-date-picker>
              </el-form-item>
              <el-form-item label="培训结束时间" prop="endTime">
                <el-date-picker :disabled="disabled" type="date" format="yyyy-MM-dd" placeholder="请输入培训结束时间"
                  v-model="ruleForm.endTime" style="width: 100%"></el-date-picker>
              </el-form-item>
              <el-form-item label="培训个人总结" prop="summaryAttachment">
                <div style="display: flex; flex-wrap: wrap">
                  <div class="demo-image__preview" v-for="(item, index) in ruleForm.summaryAttachment" :key="index">
                    <!-- <el-image
                    style="width: 100px; height: 100px; margin-right: 10px"
                    :src="item"
                    :preview-src-list="ruleForm.noticeAttachment">
                  </el-image> -->
                    <div>{{ getFileName(item) }}</div>
                    <div v-if="!disabled" class="imageDel" @click="delImage1(index)">
                      删除
                    </div>
                  </div>
                </div>
                <upload v-if="!disabled" @handleUrl="handleUrl1" :type="'all'" :isURL="false" text="请上传个人总结" />
              </el-form-item>
              <el-form-item label="参训通知" prop="noticeAttachment">
                <!-- 图片自动换行 -->
                <div style="display: flex; flex-wrap: wrap">
                  <div class="demo-image__preview" v-for="(item, index) in ruleForm.noticeAttachment" :key="index">
                    <!-- <el-image
                    style="width: 100px; height: 100px; margin-right: 10px"
                    :src="item"
                    :preview-src-list="ruleForm.noticeAttachment">
                  </el-image> -->
                    <div>{{ getFileName(item) }}</div>
                    <div v-if="!disabled" class="imageDel" @click="delImage2(index)">
                      删除
                    </div>
                  </div>
                </div>

                <upload v-if="!disabled" @handleUrl="handleUrl2" :isURL="false" text="请上传参训通知" />
              </el-form-item>
              <el-form-item label="结业证书" prop="certificateAttachment">
                <div style="display: flex; flex-wrap: wrap">
                  <div class="demo-image__preview" v-for="(item, index) in ruleForm.certificateAttachment" :key="index">
                    <!-- <el-image
                    style="width: 100px; height: 100px; margin-right: 10px"
                    :src="item"
                    :preview-src-list="ruleForm.noticeAttachment">
                  </el-image> -->
                    <div>{{ getFileName(item) }}</div>
                    <div v-if="!disabled" class="imageDel" @click="delImage3(index)">
                      删除
                    </div>
                  </div>
                </div>
                <upload v-if="!disabled" @handleUrl="handleUrl3" :isURL="false" text="请上传结业证书" />
              </el-form-item>
              <el-form-item label="科目类别" prop="courseType">
                <el-select :disabled="disabled" style="width: 100%" v-model="ruleForm.courseType" placeholder="请选择科目类别">
                  <el-option v-for="(item, index) in courseTypeList" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="预计认定学时" prop="learnHour">
                <el-input :disabled="disabled" v-model="ruleForm.learnHour" placeholder="请输入预计认定学时"></el-input>
              </el-form-item>
              <el-form-item label="培训年度" prop="learnYear">
                <!-- <el-input
                :disabled="disabled"
                v-model="ruleForm.learnYear"
                placeholder="请输入培训年度"></el-input> -->

                <el-select :disabled="disabled" style="width: 100%" v-model="ruleForm.learnYear" placeholder="请选择培训年度">
                  <el-option v-for="(item, index) in yearList" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="disabled" v-model="ruleForm.remark" placeholder="请输入备注"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm', '1')" :disabled="disabled">提交申报</el-button>
                <el-button type="primary" @click="submitForm('ruleForm', '0')" :disabled="disabled">保存草稿</el-button>
                <el-button :disabled="ruleForm.recognitionStatus != 1 ? true : false" type="primary"
                  @click="undoForm()">撤销申报</el-button>
              </el-form-item>
            </div>
            <div style="flex: 1">
              <div style="font-size: 20px; font-weight: bold; margin-bottom: 20px">
                学时认定标准
              </div>
              <div style="margin-bottom: 20px">
                1、专业技术人员脱产培训参加以更新、补充、拓展专业技术知识和能力的各级各类进修、研修、培训等，以实际学习的学时认定，但每天不超过8学时，旅途和休息时间除外。
              </div>
              <div style="margin-bottom: 20px">
                2、专业技术人员参加国际学术会议、学术讲座、学术交流的，根据活动实际实有天数按每天8学时认定:参加国家部委举办的学术会议、学术讲座、学术交流的，以参加地市级以上行业主管部门或行业协会、学会组织举办的会议、学术讲座、学术交流的，根据实有天数按每天6学时认定。
              </div>
              <div style="margin-bottom: 20px">
                3、专业技术人员参加学历教育或攻读学位，凡考试合格者，每门课程按15学时认定:课程进修考核合格者，不满6个月的，按每月10学时认定，超过6个月的，可按完成年度专业科目学时认定。
              </div>
              <div style="margin-bottom: 20px">
                4、专业技术人员到生产单位或基层开展讲学、技术咨询、技术指导登服务活动的，按实有天数每天6学时认定
              </div>
              <div style="margin-bottom: 20px">
                5、参加“西藏自治区专业技术人员继续教育网”网络学习的专业技术人员，按已经规定的学时进行认定;参加其他形式的远程教育和网络学习的，如未对学时进行规定，按实有天数每天8学时认定。
              </div>
              <div style="margin-bottom: 20px">
                6、专业技术人员参加命题的，按实际天数每半天1学时认定,
              </div>
            </div>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getSchoolClassLearnRecord,
  pageMyClassGroupList,
  offlineRecognitionList,
} from "@/api/wkApi";
// 更灵活的版本，可以指定结束年份
function generateYearList(endYear = 2026) {
  // const currentYear = new Date().getFullYear() - 1;
  // const yearList = [];

  // for (let year = currentYear; year <= endYear; year++) {
  //   yearList.push({
  //     value: year,
  //     label: year.toString(),
  //   });
  // }
  const yearList = [{
    label: "2025",
    value: 2025,
  }];
  return yearList;
}
export default {
  name: "CoursePlanPage",
  data() {
    return {
      tabs: ["公需科目", "专业科目"],
      activeTab: 0,
      courseTypes: ["线上培训_必修课", "线上培训_选修课"],
      activeCourseType: 0,
      tableData: [],
      userClass: {},
      dataList: [],
      disabled: true,
      currentId: "3",
      total: 1,
      pageSize: 10,
      dialogVisible: false,

      ruleForm: {
        recognitionType: undefined,
        courseTitle: undefined,
        department: undefined,
        learnLocation: undefined,
        learnMethod: undefined,
        startTime: undefined,
        endTime: undefined,
        courseType: undefined,
        learnHour: undefined,
        learnYear: undefined,
        remark: undefined,
        summaryAttachment: [],
        noticeAttachment: [],
        certificateAttachment: [],
      },
      labelPosition: "right",
      rules: {
        recognitionType: [
          { required: true, message: "请选择认定类型", trigger: "blur" },
        ],
        courseTitle: [
          { required: true, message: "请输入课程题目", trigger: "blur" },
        ],
        department: [
          { required: true, message: "请输入举办部门", trigger: "blur" },
        ],
        learnLocation: [
          { required: true, message: "请输入学习地点", trigger: "blur" },
        ],
        learnMethod: [
          { required: true, message: "请选择学习形式", trigger: "blur" },
        ],
        startTime: [
          { required: true, message: "请输入培训开始时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请输入培训结束时间", trigger: "blur" },
        ],
        summaryAttachment: [
          { required: true, message: "请上传培训个人总结", trigger: "blur" },
        ],
        noticeAttachment: [
          { required: true, message: "请上传参训通知", trigger: "blur" },
        ],
        courseType: [
          { required: true, message: "请选择科目类别", trigger: "blur" },
        ],
        learnHour: [
          { required: true, message: "请输入预计认定学时", trigger: "blur" },
        ],
        learnYear: [
          { required: true, message: "请输入培训年度", trigger: "blur" },
        ],
      },
      recognitionTypeList: [
        { value: 1, label: "脱产形式的进修、研修、培训等" },
        { value: 2, label: "国际学术会议、讲座、交流等" },
        { value: 3, label: "国家部委或地市级部门学术会议、讲座、交流等" },
        { value: 4, label: "学历教育、攻读学位" },
        { value: 5, label: "课程进修合格" },
        { value: 6, label: "生产单位或基层开展讲学、技术咨询、技术指导等活动" },
        { value: 7, label: "参加命题" },
      ],
      // 学习形式,1=脱产培训,2=干部选学,3=网络培训,4=在职专题研修,5=其他
      learnMethodList: [
        { value: 1, label: "脱产培训" },
        { value: 2, label: "干部选学" },
        { value: 3, label: "网络培训" },
        { value: 4, label: "在职专题研修" },
        { value: 5, label: "其他" },
      ],
      // 科目类型,1=公需科目,2=专业科目
      courseTypeList: [
        { value: 1, label: "公需科目" },
        { value: 2, label: "专业科目" },
      ],
      yearList: this.getYearsDesc(2016),
      classYear: 2025,
      type: 1,
      handleActiveCourseTagType: 1,
    };
  },
  mounted() {
    this.getSchoolClassLearnRecord();
    this.pageMyClassGroupList(1);
  },
  methods: {
    handleActiveCourseTag(val) {
      this.handleActiveCourseTagType = val;
      if (this.handleActiveCourseTagType == 1) {
        this.pageMyClassGroupList(2);
      } else {

        this.getList(1);
      }
    },
    handleClassYearChange(val) {
      this.getSchoolClassLearnRecord();
      if (this.activeTab == 1) {
        this.handleActiveCourseTagType = 1
        this.pageMyClassGroupList(2);
      } else {
        this.pageMyClassGroupList(1);
      }
    },
    getYearsDesc(startYear = 2018) {
      const current = new Date().getFullYear();
      const years = [];
      for (let y = current; y >= startYear; y--) years.push(y);
      return years;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleEdit(row, disabled) {
      this.ruleForm = row || {};
      if (row.certificateAttachmentList) {
        this.$set(row, "certificateAttachment", row.certificateAttachmentList);
      }
      if (row.noticeAttachmentList) {
        this.$set(row, "noticeAttachment", row.noticeAttachmentList);
      }
      if (row.summaryAttachmentList) {
        this.$set(row, "summaryAttachment", row.summaryAttachmentList);
      }
      this.disabled = disabled;
      this.dialogVisible = true;
      this.$forceUpdate();
    },
    // 返回图片名称
    getFileName(url) {
      // 获取文件名称,  https://blog.csdn.net/qq_41951205/article/details/104051907.png
      return url.substring(url.lastIndexOf("/") + 1);
    },

    currentChange(envt) {
      this.getList(envt);
    },
    getList(envt) {
      offlineRecognitionList({
        recognitionStatus: this.currentId,
        pageSize: this.pageSize,
        pageNo: envt ? envt : 1,
        learnYear: this.classYear,
      }).then((res) => {
        this.dataList = res.result.records;
        this.total = res.result.total;
      });
    },
    handleActiveCourse(idx) {
      this.activeCourseType = idx;
      this.pageMyClassGroupList(1);
    },
    handleActiveTab(idx) {
      this.activeTab = idx;
      this.getSchoolClassLearnRecord();
      if (idx == 1) {
        this.handleActiveCourseTagType = 1
        this.pageMyClassGroupList(2);
      } else {
        this.pageMyClassGroupList(1);
      }
    },
    // 获取我的课程
    pageMyClassGroupList(courseType) {
      let params = {
        requiredType: this.activeCourseType == 0 ? "1" : "2",
        courseType: courseType,
        pageSize: 10000,
        classYear: this.classYear,
      };
      if (params.courseType == 2) {
        delete params.requiredType;
      }
      pageMyClassGroupList(params).then((res) => {
        this.tableData = res.result.records;
      });
    },
    // 获取课程学习记录
    getSchoolClassLearnRecord() {
      getSchoolClassLearnRecord({
        classYear: this.classYear,
        courseType: this.activeTab == 0 ? "1" : "2",
      }).then((res) => {
        console.log(res);
        this.userClass = res.result || {};
      });
    },
    onHistoryPrint() {
      // this.$message("点击了历史打印记录");
      this.$emit("onHistoryPrint");
    },
    // 跳转证书打印
    onPrintCertificate() {
      if (this.activeTab == 0) {
        if (
          this.userClass.haveRequiredCourseHour <
          this.userClass.requiredCourseHour ||
          this.userClass.haveOptionalCourseHour <
          this.userClass.optionalCourseHour
        ) {
          return this.$message.error(
            `当前必修课时不满足 ${this.userClass.requiredCourseHour} 学时, 公需课选修需完成 ${this.userClass.optionalCourseHour} 学时`
          );
        }
      } else {
        if (
          this.userClass.haveOptionalCourseHour +
          this.userClass.haveRequiredCourseHour +
          this.userClass.haveOfflineLearnHour <
          this.userClass.requiredCourseHour + this.userClass.optionalCourseHour
        ) {
          return this.$message.error(
            `当前线上培训学时不满足 ${this.userClass.requiredCourseHour} 学时,`
          );
        }
      }
      // 当课时都满足时才允许打印证书
      this.$router.push(
        `/myCertificate?${this.activeTab == 0 ? "type=1" : "type=2"
        }&classYear=${this.classYear}`
      );
    },
    onPrintRegister() {
      this.$router.push(
        `/EducationRecord?${this.activeTab == 0 ? "type=1" : "type=2"
        }&classYear=${this.classYear}`
      );
    },
  },
};
</script>

<style scoped>
.course-plan-page {
  box-sizing: border-box;
  border-radius: 8px;
}

.header-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.main-title {
  font-size: 16px;
  font-weight: bold;
  margin-right: auto;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.course-plan-card {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 0 24px 24px 24px;
  margin-bottom: 24px;
}

.tab-header {
  display: flex;
  align-items: center;
  padding: 16px 0 8px 0;
  margin-bottom: 8px;
}

.tab-item {
  font-weight: bold;
  font-size: 16px;
  margin-right: 24px;
  cursor: pointer;
  padding-bottom: 6px;
  border-bottom: 2px solid transparent;
  transition: border-color 0.2s;
}

.tab-item.active {
  color: #2176ff;
  border-bottom: 2px solid #2176ff;
}

.credit-info {
  color: #e74c3c;
  font-size: 15px;
  margin: 12px 0 8px 0;
}

.credit-info .optional {
  margin-left: 16px;
}

.credit-info .history {
  color: #888;
  margin-left: 8px;
  font-size: 13px;
}

.plan-main {
  display: flex;
  align-items: flex-start;
  margin-top: 8px;
}

.plan-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 6px;
  margin-right: 18px;
  border: 1px solid #eee;
}

.plan-info {
  flex: 1;
}

.plan-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 6px;
  color: #333;
}

.plan-row {
  font-size: 14px;
  color: #555;
  margin-bottom: 4px;
}

.course-type-tabs {
  margin: 12px 0 8px 0;
}

.course-stat {
  color: #e74c3c;
  font-size: 15px;
  margin-bottom: 8px;
}
</style>
